module.exports = __webpack_public_path__ + "img/left-arrow-narrow.6ee31e3c.svg";